<template>
  <v-sheet v-if="enabledCount>0 || disabledCount>0 || archivedCount>0" class="d-flex flex-row bg-transparent">
    <v-chip v-if="enabledCount>0" class="mr-1 font-weight-bold" size="small"
            :color="getColorByStatus('ENABLED')"
            :text="enabledCount.toString()"/>
    <v-chip v-if="disabledCount>0" class="mr-1 font-weight-bold" size="small"
            :color="getColorByStatus('DISABLED')"
            :text="disabledCount.toString()"/>
    <v-chip v-if="archivedCount>0" class="mr-1 font-weight-bold" size="small"
            :color="getColorByStatus('ARCHIVED')"
            :text="archivedCount.toString()"/>
  </v-sheet>
  <span v-else>--</span>
</template>
<script setup lang="ts">
defineProps<{
  enabledCount: number
  disabledCount: number
  archivedCount: number
}>()
</script>
